import { render } from "./FormSetting.vue?vue&type=template&id=2f65f126"
import script from "./FormSetting.vue?vue&type=script&lang=js"
export * from "./FormSetting.vue?vue&type=script&lang=js"

import "./FormSetting.vue?vue&type=style&index=0&id=2f65f126&lang=css"

import exportComponent from "/var/www/dev.pbf.infonetglobal.tech/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__